"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultColors = void 0;
exports.defaultColors = {
    backgroundColor: "#ecf0f1",
    selectedBackgroundColor: "#2ecc71",
    fontColor: "#000",
    selectedFontColor: "#fff"
};
//# sourceMappingURL=defaultColors.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-switch-selector/dist/defaultColors.js
// module id = 704
// module chunks = 26